module.exports = __webpack_public_path__ + "img/page_but.5891f652.png";